import React from 'react';
import {Icon } from 'antd';
const Export = ({url}) => (
    <a href={url} target="_blank"><Icon type="file-pdf" />导 出</a>
);

export default Export;